module.exports = __webpack_public_path__ + "img/message-plus-circle.8b4740a6.svg";